var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBellRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "xmah8t9wha"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.878431 0 0 0 0 0.125490 0 0 0 0 0.125490 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#xmah8t9wha)",
    transform: "translate(-4 -4) translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M12.737 6.4c-.329 0-.596-.26-.596-.579 0-1.624-.65-3.15-1.833-4.3-.233-.226-.233-.591 0-.818.233-.226.61-.226.843 0 1.407 1.367 2.182 3.185 2.182 5.118 0 .32-.267.579-.596.579zM.596 6.4C.267 6.4 0 6.14 0 5.821 0 3.888.775 2.071 2.182.703c.233-.226.61-.226.843 0 .233.227.233.592 0 .819C1.843 2.67 1.192 4.197 1.192 5.82c0 .32-.267.579-.596.579zM12.42 9.922c-.928-.75-1.46-1.845-1.46-3.006V5.28c0-2.064-1.603-3.773-3.68-4.06V.587C7.28.262 7.005 0 6.667 0c-.339 0-.614.262-.614.587v.633c-2.077.287-3.68 1.996-3.68 4.06v1.636c0 1.16-.531 2.257-1.464 3.01-.239.196-.376.48-.376.78 0 .567.482 1.027 1.074 1.027h10.12c.592 0 1.073-.46 1.073-1.026 0-.3-.137-.585-.38-.785zM6.933 14.4c1.052 0 1.932-.689 2.134-1.6H4.8c.202.911 1.082 1.6 2.133 1.6z",
    transform: "translate(1.333 .667)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBellRed);
export default __webpack_public_path__ + "static/media/ic-bell-red.c074910614cf0fdb8668aa8c588d35d3.svg";
export { ForwardRef as ReactComponent };